// Include polyfills
import '@oddbird/popover-polyfill'
import '@js/consoleMessage'
import anchorPolyfill from '@js/cssAnchoringPolyfill'
import displayOracleMessage from '@js/consoleOracle'

onImmediate()

document.addEventListener('readystatechange', (event) => {
    switch (event.target.readyState) {
        case 'interactive':
            onReadyStateInteractive()
            break;
        case 'complete':
            onReadyStateComplete()
            break;
    }
})

function onImmediate() {
    const now = new Date()
    const hourSeconds = now.getHours() * 60 * 60
    const minuteSeconds = now.getMinutes() * 60
    const seconds = now.getSeconds() + minuteSeconds + hourSeconds

    document.documentElement.style.setProperty('--aurora-delay', `-${seconds}s`);
}

function onReadyStateInteractive() {
    anchorPolyfill()
}

function onReadyStateComplete() {
    displayOracleMessage()
}
